/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CompileTemplateResponseDto,
  CreateSectionDto,
  DeleteResponseDto,
  PromptSuggestionsResponseDto,
  ReorderSectionsDto,
  ReorderedResponseDto,
  RestoredVersionResponseDto,
  SectionHtmlResponseDto,
  SendTestEmailDto,
  SendTestEmailResponseDto,
  SessionMessagesResponseDto,
  SnapshotResponseDto,
  SuggestCopyDto,
  SuggestCopyResponseDto,
  TemplateListItemDto,
  TemplateListResponseDto,
  TemplateResponseDto,
  TemplateSectionsDetailResponseDto,
  TemplateSuggestionsControllerGetPromptSuggestionsParams,
  TemplatesControllerListTemplatesParams,
  TestRecipientsResponseDto,
  UpdateSectionDto,
  UpdateTemplateMetaDto,
  V2SectionResponseDto,
  VersionHistoryResponseDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List templates for this client
 */
export const templatesControllerListTemplates = (
  orgId: string,
  clientId: string,
  params?: TemplatesControllerListTemplatesParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<TemplateListResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getTemplatesControllerListTemplatesQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: TemplatesControllerListTemplatesParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/templates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTemplatesControllerListTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof templatesControllerListTemplates>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: TemplatesControllerListTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerListTemplates>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTemplatesControllerListTemplatesQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesControllerListTemplates>>> = ({
    signal,
  }) => templatesControllerListTemplates(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof templatesControllerListTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplatesControllerListTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerListTemplates>>
>;
export type TemplatesControllerListTemplatesQueryError = unknown;

export function useTemplatesControllerListTemplates<
  TData = Awaited<ReturnType<typeof templatesControllerListTemplates>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: undefined | TemplatesControllerListTemplatesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerListTemplates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesControllerListTemplates>>,
          TError,
          Awaited<ReturnType<typeof templatesControllerListTemplates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplatesControllerListTemplates<
  TData = Awaited<ReturnType<typeof templatesControllerListTemplates>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: TemplatesControllerListTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerListTemplates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesControllerListTemplates>>,
          TError,
          Awaited<ReturnType<typeof templatesControllerListTemplates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplatesControllerListTemplates<
  TData = Awaited<ReturnType<typeof templatesControllerListTemplates>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: TemplatesControllerListTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerListTemplates>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List templates for this client
 */

export function useTemplatesControllerListTemplates<
  TData = Awaited<ReturnType<typeof templatesControllerListTemplates>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: TemplatesControllerListTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerListTemplates>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplatesControllerListTemplatesQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a single template by id
 */
export const templatesControllerGetTemplate = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<TemplateListItemDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getTemplatesControllerGetTemplateQueryKey = (
  orgId?: string,
  clientId?: string,
  id?: string
) => {
  return [`/api/v1/organizations/${orgId}/clients/${clientId}/templates/${id}`] as const;
};

export const getTemplatesControllerGetTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof templatesControllerGetTemplate>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerGetTemplate>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTemplatesControllerGetTemplateQueryKey(orgId, clientId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesControllerGetTemplate>>> = ({
    signal,
  }) => templatesControllerGetTemplate(orgId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof templatesControllerGetTemplate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplatesControllerGetTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerGetTemplate>>
>;
export type TemplatesControllerGetTemplateQueryError = unknown;

export function useTemplatesControllerGetTemplate<
  TData = Awaited<ReturnType<typeof templatesControllerGetTemplate>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerGetTemplate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesControllerGetTemplate>>,
          TError,
          Awaited<ReturnType<typeof templatesControllerGetTemplate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplatesControllerGetTemplate<
  TData = Awaited<ReturnType<typeof templatesControllerGetTemplate>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerGetTemplate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesControllerGetTemplate>>,
          TError,
          Awaited<ReturnType<typeof templatesControllerGetTemplate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplatesControllerGetTemplate<
  TData = Awaited<ReturnType<typeof templatesControllerGetTemplate>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerGetTemplate>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single template by id
 */

export function useTemplatesControllerGetTemplate<
  TData = Awaited<ReturnType<typeof templatesControllerGetTemplate>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerGetTemplate>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplatesControllerGetTemplateQueryOptions(orgId, clientId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update template metadata
 */
export const templatesControllerUpdateTemplate = (
  orgId: string,
  clientId: string,
  id: string,
  updateTemplateMetaDto: UpdateTemplateMetaDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<TemplateResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateTemplateMetaDto,
    },
    options
  );
};

export const getTemplatesControllerUpdateTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templatesControllerUpdateTemplate>>,
    TError,
    { orgId: string; clientId: string; id: string; data: UpdateTemplateMetaDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templatesControllerUpdateTemplate>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UpdateTemplateMetaDto },
  TContext
> => {
  const mutationKey = ['templatesControllerUpdateTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templatesControllerUpdateTemplate>>,
    { orgId: string; clientId: string; id: string; data: UpdateTemplateMetaDto }
  > = (props) => {
    const { orgId, clientId, id, data } = props ?? {};

    return templatesControllerUpdateTemplate(orgId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplatesControllerUpdateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerUpdateTemplate>>
>;
export type TemplatesControllerUpdateTemplateMutationBody = UpdateTemplateMetaDto;
export type TemplatesControllerUpdateTemplateMutationError = unknown;

/**
 * @summary Update template metadata
 */
export const useTemplatesControllerUpdateTemplate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templatesControllerUpdateTemplate>>,
      TError,
      { orgId: string; clientId: string; id: string; data: UpdateTemplateMetaDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof templatesControllerUpdateTemplate>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UpdateTemplateMetaDto },
  TContext
> => {
  const mutationOptions = getTemplatesControllerUpdateTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Archive a template (soft-delete)
 */
export const templatesControllerDeleteTemplate = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<DeleteResponseDto>(
    { url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${id}`, method: 'DELETE' },
    options
  );
};

export const getTemplatesControllerDeleteTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templatesControllerDeleteTemplate>>,
    TError,
    { orgId: string; clientId: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templatesControllerDeleteTemplate>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationKey = ['templatesControllerDeleteTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templatesControllerDeleteTemplate>>,
    { orgId: string; clientId: string; id: string }
  > = (props) => {
    const { orgId, clientId, id } = props ?? {};

    return templatesControllerDeleteTemplate(orgId, clientId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplatesControllerDeleteTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerDeleteTemplate>>
>;

export type TemplatesControllerDeleteTemplateMutationError = unknown;

/**
 * @summary Archive a template (soft-delete)
 */
export const useTemplatesControllerDeleteTemplate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templatesControllerDeleteTemplate>>,
      TError,
      { orgId: string; clientId: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof templatesControllerDeleteTemplate>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationOptions = getTemplatesControllerDeleteTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get all sections for a template with rendered HTML
 */
export const templateSectionsControllerGetTemplateSections = (
  orgId: string,
  clientId: string,
  templateId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<TemplateSectionsDetailResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/sections`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getTemplateSectionsControllerGetTemplateSectionsQueryKey = (
  orgId?: string,
  clientId?: string,
  templateId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/sections`,
  ] as const;
};

export const getTemplateSectionsControllerGetTemplateSectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTemplateSectionsControllerGetTemplateSectionsQueryKey(orgId, clientId, templateId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>
  > = ({ signal }) =>
    templateSectionsControllerGetTemplateSections(
      orgId,
      clientId,
      templateId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && templateId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplateSectionsControllerGetTemplateSectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>
>;
export type TemplateSectionsControllerGetTemplateSectionsQueryError = unknown;

export function useTemplateSectionsControllerGetTemplateSections<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
          TError,
          Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateSectionsControllerGetTemplateSections<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
          TError,
          Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateSectionsControllerGetTemplateSections<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all sections for a template with rendered HTML
 */

export function useTemplateSectionsControllerGetTemplateSections<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetTemplateSections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplateSectionsControllerGetTemplateSectionsQueryOptions(
    orgId,
    clientId,
    templateId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a new section to a template
 */
export const templateSectionsControllerAddSection = (
  orgId: string,
  clientId: string,
  templateId: string,
  createSectionDto: CreateSectionDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<V2SectionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/sections`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSectionDto,
      signal,
    },
    options
  );
};

export const getTemplateSectionsControllerAddSectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templateSectionsControllerAddSection>>,
    TError,
    { orgId: string; clientId: string; templateId: string; data: CreateSectionDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templateSectionsControllerAddSection>>,
  TError,
  { orgId: string; clientId: string; templateId: string; data: CreateSectionDto },
  TContext
> => {
  const mutationKey = ['templateSectionsControllerAddSection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templateSectionsControllerAddSection>>,
    { orgId: string; clientId: string; templateId: string; data: CreateSectionDto }
  > = (props) => {
    const { orgId, clientId, templateId, data } = props ?? {};

    return templateSectionsControllerAddSection(orgId, clientId, templateId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplateSectionsControllerAddSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof templateSectionsControllerAddSection>>
>;
export type TemplateSectionsControllerAddSectionMutationBody = CreateSectionDto;
export type TemplateSectionsControllerAddSectionMutationError = unknown;

/**
 * @summary Add a new section to a template
 */
export const useTemplateSectionsControllerAddSection = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templateSectionsControllerAddSection>>,
      TError,
      { orgId: string; clientId: string; templateId: string; data: CreateSectionDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof templateSectionsControllerAddSection>>,
  TError,
  { orgId: string; clientId: string; templateId: string; data: CreateSectionDto },
  TContext
> => {
  const mutationOptions = getTemplateSectionsControllerAddSectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Compile template to email-ready HTML with composited sections
 */
export const templateSectionsControllerCompileTemplate = (
  orgId: string,
  clientId: string,
  templateId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CompileTemplateResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/compile`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getTemplateSectionsControllerCompileTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templateSectionsControllerCompileTemplate>>,
    TError,
    { orgId: string; clientId: string; templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templateSectionsControllerCompileTemplate>>,
  TError,
  { orgId: string; clientId: string; templateId: string },
  TContext
> => {
  const mutationKey = ['templateSectionsControllerCompileTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templateSectionsControllerCompileTemplate>>,
    { orgId: string; clientId: string; templateId: string }
  > = (props) => {
    const { orgId, clientId, templateId } = props ?? {};

    return templateSectionsControllerCompileTemplate(orgId, clientId, templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplateSectionsControllerCompileTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof templateSectionsControllerCompileTemplate>>
>;

export type TemplateSectionsControllerCompileTemplateMutationError = unknown;

/**
 * @summary Compile template to email-ready HTML with composited sections
 */
export const useTemplateSectionsControllerCompileTemplate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templateSectionsControllerCompileTemplate>>,
      TError,
      { orgId: string; clientId: string; templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof templateSectionsControllerCompileTemplate>>,
  TError,
  { orgId: string; clientId: string; templateId: string },
  TContext
> => {
  const mutationOptions = getTemplateSectionsControllerCompileTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get the stored compiled HTML, compiling only if there is none yet
 */
export const templateSectionsControllerGetCompiledTemplate = (
  orgId: string,
  clientId: string,
  templateId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CompileTemplateResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/compiled`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getTemplateSectionsControllerGetCompiledTemplateQueryKey = (
  orgId?: string,
  clientId?: string,
  templateId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/compiled`,
  ] as const;
};

export const getTemplateSectionsControllerGetCompiledTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTemplateSectionsControllerGetCompiledTemplateQueryKey(orgId, clientId, templateId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>
  > = ({ signal }) =>
    templateSectionsControllerGetCompiledTemplate(
      orgId,
      clientId,
      templateId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && templateId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplateSectionsControllerGetCompiledTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>
>;
export type TemplateSectionsControllerGetCompiledTemplateQueryError = unknown;

export function useTemplateSectionsControllerGetCompiledTemplate<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
          TError,
          Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateSectionsControllerGetCompiledTemplate<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
          TError,
          Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateSectionsControllerGetCompiledTemplate<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the stored compiled HTML, compiling only if there is none yet
 */

export function useTemplateSectionsControllerGetCompiledTemplate<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetCompiledTemplate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplateSectionsControllerGetCompiledTemplateQueryOptions(
    orgId,
    clientId,
    templateId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get rendered HTML for a single section
 */
export const templateSectionsControllerGetSectionHtml = (
  orgId: string,
  clientId: string,
  templateId: string,
  sectionId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SectionHtmlResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/sections/${sectionId}/html`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getTemplateSectionsControllerGetSectionHtmlQueryKey = (
  orgId?: string,
  clientId?: string,
  templateId?: string,
  sectionId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/sections/${sectionId}/html`,
  ] as const;
};

export const getTemplateSectionsControllerGetSectionHtmlQueryOptions = <
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  sectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTemplateSectionsControllerGetSectionHtmlQueryKey(orgId, clientId, templateId, sectionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>
  > = ({ signal }) =>
    templateSectionsControllerGetSectionHtml(
      orgId,
      clientId,
      templateId,
      sectionId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && templateId && sectionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplateSectionsControllerGetSectionHtmlQueryResult = NonNullable<
  Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>
>;
export type TemplateSectionsControllerGetSectionHtmlQueryError = unknown;

export function useTemplateSectionsControllerGetSectionHtml<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  sectionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
          TError,
          Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateSectionsControllerGetSectionHtml<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  sectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
          TError,
          Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateSectionsControllerGetSectionHtml<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  sectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get rendered HTML for a single section
 */

export function useTemplateSectionsControllerGetSectionHtml<
  TData = Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  sectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSectionsControllerGetSectionHtml>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplateSectionsControllerGetSectionHtmlQueryOptions(
    orgId,
    clientId,
    templateId,
    sectionId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Reorder sections by providing an ordered array of section IDs
 */
export const templateSectionsControllerReorderSections = (
  orgId: string,
  clientId: string,
  templateId: string,
  reorderSectionsDto: ReorderSectionsDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<ReorderedResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/sections/reorder`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: reorderSectionsDto,
    },
    options
  );
};

export const getTemplateSectionsControllerReorderSectionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templateSectionsControllerReorderSections>>,
    TError,
    { orgId: string; clientId: string; templateId: string; data: ReorderSectionsDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templateSectionsControllerReorderSections>>,
  TError,
  { orgId: string; clientId: string; templateId: string; data: ReorderSectionsDto },
  TContext
> => {
  const mutationKey = ['templateSectionsControllerReorderSections'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templateSectionsControllerReorderSections>>,
    { orgId: string; clientId: string; templateId: string; data: ReorderSectionsDto }
  > = (props) => {
    const { orgId, clientId, templateId, data } = props ?? {};

    return templateSectionsControllerReorderSections(
      orgId,
      clientId,
      templateId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplateSectionsControllerReorderSectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof templateSectionsControllerReorderSections>>
>;
export type TemplateSectionsControllerReorderSectionsMutationBody = ReorderSectionsDto;
export type TemplateSectionsControllerReorderSectionsMutationError = unknown;

/**
 * @summary Reorder sections by providing an ordered array of section IDs
 */
export const useTemplateSectionsControllerReorderSections = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templateSectionsControllerReorderSections>>,
      TError,
      { orgId: string; clientId: string; templateId: string; data: ReorderSectionsDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof templateSectionsControllerReorderSections>>,
  TError,
  { orgId: string; clientId: string; templateId: string; data: ReorderSectionsDto },
  TContext
> => {
  const mutationOptions = getTemplateSectionsControllerReorderSectionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update a section (contentVars, imageVars, or layoutId)
 */
export const templateSectionsControllerUpdateSection = (
  orgId: string,
  clientId: string,
  templateId: string,
  sectionId: string,
  updateSectionDto: UpdateSectionDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<V2SectionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/sections/${sectionId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateSectionDto,
    },
    options
  );
};

export const getTemplateSectionsControllerUpdateSectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templateSectionsControllerUpdateSection>>,
    TError,
    {
      orgId: string;
      clientId: string;
      templateId: string;
      sectionId: string;
      data: UpdateSectionDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templateSectionsControllerUpdateSection>>,
  TError,
  {
    orgId: string;
    clientId: string;
    templateId: string;
    sectionId: string;
    data: UpdateSectionDto;
  },
  TContext
> => {
  const mutationKey = ['templateSectionsControllerUpdateSection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templateSectionsControllerUpdateSection>>,
    {
      orgId: string;
      clientId: string;
      templateId: string;
      sectionId: string;
      data: UpdateSectionDto;
    }
  > = (props) => {
    const { orgId, clientId, templateId, sectionId, data } = props ?? {};

    return templateSectionsControllerUpdateSection(
      orgId,
      clientId,
      templateId,
      sectionId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplateSectionsControllerUpdateSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof templateSectionsControllerUpdateSection>>
>;
export type TemplateSectionsControllerUpdateSectionMutationBody = UpdateSectionDto;
export type TemplateSectionsControllerUpdateSectionMutationError = unknown;

/**
 * @summary Update a section (contentVars, imageVars, or layoutId)
 */
export const useTemplateSectionsControllerUpdateSection = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templateSectionsControllerUpdateSection>>,
      TError,
      {
        orgId: string;
        clientId: string;
        templateId: string;
        sectionId: string;
        data: UpdateSectionDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof templateSectionsControllerUpdateSection>>,
  TError,
  {
    orgId: string;
    clientId: string;
    templateId: string;
    sectionId: string;
    data: UpdateSectionDto;
  },
  TContext
> => {
  const mutationOptions = getTemplateSectionsControllerUpdateSectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Remove a section from a template
 */
export const templateSectionsControllerDeleteSection = (
  orgId: string,
  clientId: string,
  templateId: string,
  sectionId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<DeleteResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/sections/${sectionId}`,
      method: 'DELETE',
    },
    options
  );
};

export const getTemplateSectionsControllerDeleteSectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templateSectionsControllerDeleteSection>>,
    TError,
    { orgId: string; clientId: string; templateId: string; sectionId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templateSectionsControllerDeleteSection>>,
  TError,
  { orgId: string; clientId: string; templateId: string; sectionId: string },
  TContext
> => {
  const mutationKey = ['templateSectionsControllerDeleteSection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templateSectionsControllerDeleteSection>>,
    { orgId: string; clientId: string; templateId: string; sectionId: string }
  > = (props) => {
    const { orgId, clientId, templateId, sectionId } = props ?? {};

    return templateSectionsControllerDeleteSection(
      orgId,
      clientId,
      templateId,
      sectionId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplateSectionsControllerDeleteSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof templateSectionsControllerDeleteSection>>
>;

export type TemplateSectionsControllerDeleteSectionMutationError = unknown;

/**
 * @summary Remove a section from a template
 */
export const useTemplateSectionsControllerDeleteSection = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templateSectionsControllerDeleteSection>>,
      TError,
      { orgId: string; clientId: string; templateId: string; sectionId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof templateSectionsControllerDeleteSection>>,
  TError,
  { orgId: string; clientId: string; templateId: string; sectionId: string },
  TContext
> => {
  const mutationOptions = getTemplateSectionsControllerDeleteSectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get generation/remix chat messages for a template
 */
export const templateGenerationControllerGetTemplateMessages = (
  orgId: string,
  clientId: string,
  templateId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SessionMessagesResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/messages`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getTemplateGenerationControllerGetTemplateMessagesQueryKey = (
  orgId?: string,
  clientId?: string,
  templateId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/messages`,
  ] as const;
};

export const getTemplateGenerationControllerGetTemplateMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTemplateGenerationControllerGetTemplateMessagesQueryKey(orgId, clientId, templateId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>
  > = ({ signal }) =>
    templateGenerationControllerGetTemplateMessages(
      orgId,
      clientId,
      templateId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && templateId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplateGenerationControllerGetTemplateMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>
>;
export type TemplateGenerationControllerGetTemplateMessagesQueryError = unknown;

export function useTemplateGenerationControllerGetTemplateMessages<
  TData = Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
          TError,
          Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateGenerationControllerGetTemplateMessages<
  TData = Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
          TError,
          Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateGenerationControllerGetTemplateMessages<
  TData = Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get generation/remix chat messages for a template
 */

export function useTemplateGenerationControllerGetTemplateMessages<
  TData = Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateGenerationControllerGetTemplateMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplateGenerationControllerGetTemplateMessagesQueryOptions(
    orgId,
    clientId,
    templateId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get version history for a template
 */
export const templateHistoryControllerGetVersionHistory = (
  orgId: string,
  clientId: string,
  templateId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<VersionHistoryResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/versions`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getTemplateHistoryControllerGetVersionHistoryQueryKey = (
  orgId?: string,
  clientId?: string,
  templateId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/versions`,
  ] as const;
};

export const getTemplateHistoryControllerGetVersionHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTemplateHistoryControllerGetVersionHistoryQueryKey(orgId, clientId, templateId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>
  > = ({ signal }) =>
    templateHistoryControllerGetVersionHistory(orgId, clientId, templateId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && templateId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplateHistoryControllerGetVersionHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>
>;
export type TemplateHistoryControllerGetVersionHistoryQueryError = unknown;

export function useTemplateHistoryControllerGetVersionHistory<
  TData = Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
          TError,
          Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateHistoryControllerGetVersionHistory<
  TData = Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
          TError,
          Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateHistoryControllerGetVersionHistory<
  TData = Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get version history for a template
 */

export function useTemplateHistoryControllerGetVersionHistory<
  TData = Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateHistoryControllerGetVersionHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplateHistoryControllerGetVersionHistoryQueryOptions(
    orgId,
    clientId,
    templateId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Restore a previous version of a template
 */
export const templateHistoryControllerRestoreVersion = (
  orgId: string,
  clientId: string,
  templateId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<RestoredVersionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/restore`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getTemplateHistoryControllerRestoreVersionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templateHistoryControllerRestoreVersion>>,
    TError,
    { orgId: string; clientId: string; templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templateHistoryControllerRestoreVersion>>,
  TError,
  { orgId: string; clientId: string; templateId: string },
  TContext
> => {
  const mutationKey = ['templateHistoryControllerRestoreVersion'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templateHistoryControllerRestoreVersion>>,
    { orgId: string; clientId: string; templateId: string }
  > = (props) => {
    const { orgId, clientId, templateId } = props ?? {};

    return templateHistoryControllerRestoreVersion(orgId, clientId, templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplateHistoryControllerRestoreVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof templateHistoryControllerRestoreVersion>>
>;

export type TemplateHistoryControllerRestoreVersionMutationError = unknown;

/**
 * @summary Restore a previous version of a template
 */
export const useTemplateHistoryControllerRestoreVersion = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templateHistoryControllerRestoreVersion>>,
      TError,
      { orgId: string; clientId: string; templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof templateHistoryControllerRestoreVersion>>,
  TError,
  { orgId: string; clientId: string; templateId: string },
  TContext
> => {
  const mutationOptions = getTemplateHistoryControllerRestoreVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Snapshot the current template state before editing
 */
export const templateHistoryControllerSnapshotTemplate = (
  orgId: string,
  clientId: string,
  templateId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SnapshotResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/snapshot`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getTemplateHistoryControllerSnapshotTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templateHistoryControllerSnapshotTemplate>>,
    TError,
    { orgId: string; clientId: string; templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templateHistoryControllerSnapshotTemplate>>,
  TError,
  { orgId: string; clientId: string; templateId: string },
  TContext
> => {
  const mutationKey = ['templateHistoryControllerSnapshotTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templateHistoryControllerSnapshotTemplate>>,
    { orgId: string; clientId: string; templateId: string }
  > = (props) => {
    const { orgId, clientId, templateId } = props ?? {};

    return templateHistoryControllerSnapshotTemplate(orgId, clientId, templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplateHistoryControllerSnapshotTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof templateHistoryControllerSnapshotTemplate>>
>;

export type TemplateHistoryControllerSnapshotTemplateMutationError = unknown;

/**
 * @summary Snapshot the current template state before editing
 */
export const useTemplateHistoryControllerSnapshotTemplate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templateHistoryControllerSnapshotTemplate>>,
      TError,
      { orgId: string; clientId: string; templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof templateHistoryControllerSnapshotTemplate>>,
  TError,
  { orgId: string; clientId: string; templateId: string },
  TContext
> => {
  const mutationOptions = getTemplateHistoryControllerSnapshotTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * One set per create surface, cached per (client, type) until the next day. A miss returns generating:true and warms the set in the background; poll until it flips.
 * @summary Get personalized prompt suggestions for this client
 */
export const templateSuggestionsControllerGetPromptSuggestions = (
  orgId: string,
  clientId: string,
  params?: TemplateSuggestionsControllerGetPromptSuggestionsParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<PromptSuggestionsResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/prompt-suggestions`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getTemplateSuggestionsControllerGetPromptSuggestionsQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: TemplateSuggestionsControllerGetPromptSuggestionsParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/templates/prompt-suggestions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTemplateSuggestionsControllerGetPromptSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: TemplateSuggestionsControllerGetPromptSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTemplateSuggestionsControllerGetPromptSuggestionsQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>
  > = ({ signal }) =>
    templateSuggestionsControllerGetPromptSuggestions(
      orgId,
      clientId,
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplateSuggestionsControllerGetPromptSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>
>;
export type TemplateSuggestionsControllerGetPromptSuggestionsQueryError = unknown;

export function useTemplateSuggestionsControllerGetPromptSuggestions<
  TData = Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: undefined | TemplateSuggestionsControllerGetPromptSuggestionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
          TError,
          Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateSuggestionsControllerGetPromptSuggestions<
  TData = Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: TemplateSuggestionsControllerGetPromptSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
          TError,
          Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateSuggestionsControllerGetPromptSuggestions<
  TData = Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: TemplateSuggestionsControllerGetPromptSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get personalized prompt suggestions for this client
 */

export function useTemplateSuggestionsControllerGetPromptSuggestions<
  TData = Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: TemplateSuggestionsControllerGetPromptSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateSuggestionsControllerGetPromptSuggestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplateSuggestionsControllerGetPromptSuggestionsQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get AI suggestions for subject line or preview text
 */
export const templateSuggestionsControllerSuggestCopy = (
  orgId: string,
  clientId: string,
  templateId: string,
  suggestCopyDto: SuggestCopyDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SuggestCopyResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/suggest-copy`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: suggestCopyDto,
      signal,
    },
    options
  );
};

export const getTemplateSuggestionsControllerSuggestCopyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templateSuggestionsControllerSuggestCopy>>,
    TError,
    { orgId: string; clientId: string; templateId: string; data: SuggestCopyDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templateSuggestionsControllerSuggestCopy>>,
  TError,
  { orgId: string; clientId: string; templateId: string; data: SuggestCopyDto },
  TContext
> => {
  const mutationKey = ['templateSuggestionsControllerSuggestCopy'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templateSuggestionsControllerSuggestCopy>>,
    { orgId: string; clientId: string; templateId: string; data: SuggestCopyDto }
  > = (props) => {
    const { orgId, clientId, templateId, data } = props ?? {};

    return templateSuggestionsControllerSuggestCopy(
      orgId,
      clientId,
      templateId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplateSuggestionsControllerSuggestCopyMutationResult = NonNullable<
  Awaited<ReturnType<typeof templateSuggestionsControllerSuggestCopy>>
>;
export type TemplateSuggestionsControllerSuggestCopyMutationBody = SuggestCopyDto;
export type TemplateSuggestionsControllerSuggestCopyMutationError = unknown;

/**
 * @summary Get AI suggestions for subject line or preview text
 */
export const useTemplateSuggestionsControllerSuggestCopy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templateSuggestionsControllerSuggestCopy>>,
      TError,
      { orgId: string; clientId: string; templateId: string; data: SuggestCopyDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof templateSuggestionsControllerSuggestCopy>>,
  TError,
  { orgId: string; clientId: string; templateId: string; data: SuggestCopyDto },
  TContext
> => {
  const mutationOptions = getTemplateSuggestionsControllerSuggestCopyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get saved test email recipients for this client
 */
export const templateTestingControllerGetTestRecipients = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<TestRecipientsResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/test-recipients`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getTemplateTestingControllerGetTestRecipientsQueryKey = (
  orgId?: string,
  clientId?: string
) => {
  return [`/api/v1/organizations/${orgId}/clients/${clientId}/templates/test-recipients`] as const;
};

export const getTemplateTestingControllerGetTestRecipientsQueryOptions = <
  TData = Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTemplateTestingControllerGetTestRecipientsQueryKey(orgId, clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>
  > = ({ signal }) =>
    templateTestingControllerGetTestRecipients(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplateTestingControllerGetTestRecipientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>
>;
export type TemplateTestingControllerGetTestRecipientsQueryError = unknown;

export function useTemplateTestingControllerGetTestRecipients<
  TData = Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
          TError,
          Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateTestingControllerGetTestRecipients<
  TData = Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
          TError,
          Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateTestingControllerGetTestRecipients<
  TData = Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get saved test email recipients for this client
 */

export function useTemplateTestingControllerGetTestRecipients<
  TData = Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof templateTestingControllerGetTestRecipients>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplateTestingControllerGetTestRecipientsQueryOptions(
    orgId,
    clientId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Send a test email for this template
 */
export const templateTestingControllerSendTestEmail = (
  orgId: string,
  clientId: string,
  templateId: string,
  sendTestEmailDto: SendTestEmailDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SendTestEmailResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/templates/${templateId}/send-test`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sendTestEmailDto,
      signal,
    },
    options
  );
};

export const getTemplateTestingControllerSendTestEmailMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templateTestingControllerSendTestEmail>>,
    TError,
    { orgId: string; clientId: string; templateId: string; data: SendTestEmailDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templateTestingControllerSendTestEmail>>,
  TError,
  { orgId: string; clientId: string; templateId: string; data: SendTestEmailDto },
  TContext
> => {
  const mutationKey = ['templateTestingControllerSendTestEmail'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templateTestingControllerSendTestEmail>>,
    { orgId: string; clientId: string; templateId: string; data: SendTestEmailDto }
  > = (props) => {
    const { orgId, clientId, templateId, data } = props ?? {};

    return templateTestingControllerSendTestEmail(
      orgId,
      clientId,
      templateId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplateTestingControllerSendTestEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof templateTestingControllerSendTestEmail>>
>;
export type TemplateTestingControllerSendTestEmailMutationBody = SendTestEmailDto;
export type TemplateTestingControllerSendTestEmailMutationError = unknown;

/**
 * @summary Send a test email for this template
 */
export const useTemplateTestingControllerSendTestEmail = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templateTestingControllerSendTestEmail>>,
      TError,
      { orgId: string; clientId: string; templateId: string; data: SendTestEmailDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof templateTestingControllerSendTestEmail>>,
  TError,
  { orgId: string; clientId: string; templateId: string; data: SendTestEmailDto },
  TContext
> => {
  const mutationOptions = getTemplateTestingControllerSendTestEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
